import { Edges, Grid } from '@react-three/drei'
import * as THREE from 'three'
import type { VehicleSceneTheme } from './VehicleSceneTheme'

const M = (mm: number) => mm / 1000

export function VehicleCargoVolume({
  length,
  width,
  height,
  theme,
  bodyOpacity = 0.08,
}: {
  length: number
  width: number
  height: number
  theme: VehicleSceneTheme
  /** À zéro, les arêtes restent visibles sans couvrir les marchandises. */
  bodyOpacity?: number
}) {
  const args: [number, number, number] = [M(length), M(height), M(width)]
  const position: [number, number, number] = [M(length / 2), M(height / 2), M(width / 2)]

  return (
    <group>
      <mesh position={position} castShadow>
        <boxGeometry args={args} />
        <meshPhysicalMaterial
          color={theme.cargoGlass}
          transparent
          opacity={bodyOpacity}
          depthWrite={false}
          roughness={0.3}
          metalness={0}
          transmission={0.15}
          side={THREE.DoubleSide}
        />
        <Edges scale={1} color={theme.cargoEdge} />
      </mesh>
      <Grid
        position={[M(length / 2), 0.005, M(width / 2)]}
        args={[M(length), M(width)]}
        cellSize={M(length) / 8}
        cellThickness={0.5}
        cellColor={theme.grid}
        sectionSize={M(length) / 2}
        sectionThickness={0.8}
        sectionColor={theme.grid}
        fadeDistance={50}
        fadeStrength={1}
        followCamera={false}
        infiniteGrid={false}
      />
    </group>
  )
}
